import { AxiosResponse } from 'axios';
import { Environment } from 'src/utils/Environment';
import { InstallmentPlanCode } from '../dcs/bundle';

type PricingDetail = {
  productId: string;
  description: string;
  feeMinAbsolute: number;
  feeMin: number;
  feeDefault: number;
  feeMax: number;
  feeMaxAbsolute: number;
  minAmountAbsolute: number;
  minAmt: number;
  defaultAmt: number;
  maxAmt: number;
  maxAmountAbsolute: number;
  quantity: number;
  rateMinAbsolute: number;
  rateMin: number;
  rateDefault: number;
  rateMax: number;
  rateMaxAbsolute: number;
  productName: string;
  productType: string;
  isOverride: boolean;
  override: boolean;
  showoncart: boolean;
  purchaseType: InstallmentPlanCode;
  addIfNotPresent: boolean;
  removeIfPresent: boolean;
};

type ProductItem = {
  productId: string;
  quantity: number;
  productName: string;
};

export type Promotion = {
  promotionName: string;
  promoCode: string;
  promotionId: string;
  promotionDescription: string;
  promotionLongDescription: string;
  startDate: string;
  endDate: string;
  applicableToProductIds: ProductItem[];
  pricingDetails: PricingDetail[];
};

export const fetchPromotion = async ({
  resellerId,
  cartProductIds,
  promoCode,
}: {
  resellerId: string;
  cartProductIds: string[];
  promoCode: string;
}): Promise<AxiosResponse<Promotion>> => {
  const productIds = cartProductIds.join(',');
  return Environment.current.growthApiClient.get<Promotion>(
    `v3/shop/resellers/${resellerId}/promos/${promoCode}?cartProductIds=${productIds}`
  );
};
